import type { ReadonlySignal, Signal } from "@suse-o11y/signal";
import { type Key, createContext } from "react";

import type { ImmutableMap } from "~/tools/immutable-map";
import type { ImmutableSet } from "~/tools/immutable-set";
import { useRequiredContext } from "~/tools/use-required-context";

import type { TableOverflowState } from "./_overflow-state";
import type { TableColOrder } from "./col-order";

export interface TableContextValue {
	sortedBy: Signal<ImmutableSet<TableColOrder>>;
	virtualRowsState: Signal<ImmutableMap<Key, unknown>>;
	overflowState: ReadonlySignal<undefined | TableOverflowState>;
	scrollElement: null | HTMLElement;
}

const TableContext = createContext<null | TableContextValue>(null);

export const TableContextProvider = TableContext.Provider;

export const useTableContext = (): TableContextValue =>
	useRequiredContext(TableContext, {
		providerName: "TableContextProvider",
	});

export const VirtualRowContext = createContext<null | Key>(null);
